import * as React from 'react';
import { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { getSurveyVerifyAsync } from '../../ajax/requests';

import { SurveyTokenData } from '../../shared/surveys';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import {
    CenterState,
    CenterStateInner,
    LoadingText,
    Page,
    PageShell,
    SurveyFormView,
} from './SurveyFormView';
import { BannerAlert } from './SurveyFormView.styles';

const SurveyResponse: React.FC = () => {
    const t = useTranslations();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [tokenData, setTokenData] = useState<SurveyTokenData | null>(null);
    const [token, setToken] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenParam = params.get('token');

        if (!tokenParam) {
            setError(t(TK.surveyLinkExpired));
            setLoading(false);
            return;
        }

        setToken(tokenParam);

        getSurveyVerifyAsync(tokenParam)
            .then((data: SurveyTokenData) => {
                setTokenData(data);
                setLoading(false);
            })
            .catch(() => {
                setError(t(TK.surveyLinkExpired));
                setLoading(false);
            });
    }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return (
            <Page>
                <PageShell>
                    <CenterState>
                        <CenterStateInner>
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                            <LoadingText>{t(TK.loading)}...</LoadingText>
                        </CenterStateInner>
                    </CenterState>
                </PageShell>
            </Page>
        );
    }

    if (error && !tokenData) {
        return (
            <Page>
                <PageShell>
                    <CenterState>
                        <CenterStateInner>
                            <BannerAlert color="danger">
                                <h4>{t(TK.error)}</h4>
                                <p>{error}</p>
                            </BannerAlert>
                        </CenterStateInner>
                    </CenterState>
                </PageShell>
            </Page>
        );
    }

    if (!tokenData) {
        return null;
    }

    return <SurveyFormView tokenData={tokenData} token={token} />;
};

export default SurveyResponse;
